// 默认忽略的错误
export const defaultIgnoreErrors = [
  // 网络错误
  'Network request failed',
  'NetworkError',
  'Failed to fetch',
  'Network Error',

  // 浏览器扩展错误
  'top.GLOBALS',
  'chrome-extension://',
  'moz-extension://',

  // 第三方脚本错误
  'Script error',

  // 取消的请求
  'AbortError',
  'Request aborted',
  'Non-Error promise rejection captured',

  // HTTP 4xx 错误相关
  /4\d{2}/, // 匹配所有 4xx 状态码
  /status code 4\d{2}/i,
  /Request failed with status code 4\d{2}/i,

  // 常见的 4xx 错误消息
  'Bad Request',
  'Unauthorized',
  'Payment Required',
  'Forbidden',
  'Not Found',
  'Method Not Allowed',
  'Not Acceptable',
  'Proxy Authentication Required',
  'Request Timeout',
  'Conflict',
  'Gone',
  'Length Required',
  'Precondition Failed',
  'Payload Too Large',
  'URI Too Long',
  'Unsupported Media Type',
  'Range Not Satisfiable',
  'Expectation Failed',
  'Unprocessable Entity',
  'Too Many Requests',
  '请求未授权',
  '缺失令牌,鉴权失败',

  // Axios 特定的 4xx 错误格式
  /AxiosError.*4\d{2}/,

  // BladeX 业务错
  /^\d+:.+$/
]

// 公司允许的域名
export const companyAllowUrls = [
  /https?:\/\/(.*\.)?twyfordtile\.net/,
  /https?:\/\/(.*\.)?twyfordtile\.top/,
  /https?:\/\/(.*\.)?twyfordtile\.com/
]

// 默认配置
export const defaultConfig = {
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  enablePerformance: true,
  enableReplay: false
}
